import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {
  ColDef,
  Column, ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
  SelectionChangedEvent
} from "ag-grid-community";
import {debounceTime, distinctUntilChanged, lastValueFrom, map, Observable} from "rxjs";

import {NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";

import {Location} from "@angular/common";

import {NgSelectComponent} from "@ng-select/ng-select";
import {FormControl, NgModel, Validators} from "@angular/forms";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { MenusService } from 'src/app/_services/menu.service';
import { AlertService } from 'src/app/_services/alert.service';
import { SideNavService } from '../../layout/sidebar/side-name.service';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { StorageService } from 'src/app/_services/storage.service';
import { MerchantFilter } from '../resellers/reseller-master/reseller.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'


const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

// const API_URL = 'http://localhost:8000'
export interface IMerchantData {
  "bussinessCategories": string,
  "bussinessSubCategories": string,
  "riskLevel": string,
  "riskLevelCode": string,
  "bussinessCategoriesID": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string,
  
}

export class DetailCellRenderer implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = '<h1 style="padding: 20px;">My Custom Detail</h1>';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
interface DropDownValues {
  FieldValue: number,
  FieldText: string
}

@Component({
  selector: 'app-merchant-summary',
  templateUrl: './merchant-summary.component.html',
  styleUrls: ['./merchant-summary.component.scss']
})
export class MerchantSummaryComponent implements OnInit {
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  // @Output() isEdit: EventEmitter<any> = new EventEmitter<any>();
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: any ;
  public resellerPartnerId:any;
  public Status:string;
  public searchFromDate: string;
  public searchToDate: string;
  public selectedMerchant: string;
  public valevent1:any="all"
 public valevent2:any=null
 public valevent3:any=null

 riskScore:any=""
 merchantID:any=""
 bussinessCategory:any=""
 subBussinessCategory:any=""
 bussinesstype:any=""
  public page: number = 1  
  merchantStatus: any;
  public detailCellRenderer = new DetailCellRenderer;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 300,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  dynamicDate:any =this.getToday();
  public rowData!: IMerchantData[];
  tablecolumn: any;
  currentPage: number = 1;
  globalSearch: string = '';
  collectionSize: number = 0;
  collectiondata: number=0
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  Merchantdata: any;
  modalConfigBlocked: ModalConfig;
  public menuItems: any;
  public permissions: any = '';
  currentDate:any=new Date();
  tableInfo: any;
  activityData:any;
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('categorysearch') private categorysearch: NgSelectComponent;
  @ViewChild('subCategorySearch') private subCategorySearch: NgSelectComponent;
  @ViewChild('risksearch') private risksearch: NgSelectComponent; 
  activityResponse: any;
  newselectedAttributes: any
  // public columnDefs: ColDef[] = [
  //   {field: 'bussinessCategories', tooltipField: 'bussinessCategories', headerName: 'Business Category',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
  //   {field: 'bussinessSubCategories',tooltipField: 'bussinessSubCategories', headerName: 'Business SubCategory',resizable: true},
  //   {field: 'riskLevel' ,tooltipField: 'riskLevel', headerName: 'Risk Level',resizable: true},
  //   {field: 'riskLevelCode',tooltipField: 'riskLevelCode', headerName: 'Risk Level Code',resizable: true},
  //   {field: 'bussinessCategoriesID', tooltipField:'bussinessCategoriesID',headerName: 'Bussiness Categories ID',hide:true,resizable: true},  
  //   {field: 'ID', tooltipField:'ID',headerName: 'ID' ,hide:true,resizable: true},   
    
    
  // ];


  public columnDefs:ColDef[] = [
    
    { field: 'merchantId',tooltipField: 'merchantId',headerName: 'Merchant Id',sortable: true},
    { field: 'tradeName',tooltipField: 'tradeName',headerName: 'Business Name'},
    { field: 'legalName',tooltipField: 'legalName',headerName: 'Legal Name'},
    { field: 'businessCategory',tooltipField: 'businessCategory',headerName: 'Business category'},
    { field: 'businessSubCategory',tooltipField: 'businessSubCategory',headerName: 'Business Sub Category'},
    { field: 'businessType',tooltipField: 'businessType',headerName: 'Business Type'},     
    { field: 'cin', tooltipField: 'cin',headerName: 'CIN'},
    { field: 'gsts',tooltipField: 'gsts',headerName: 'GSTIN Number'}, 
    { field: 'managements',tooltipField: 'managements',headerName: 'Management' },     
    { field: 'riskScore',tooltipField: 'riskScore',headerName: 'Risk Score'},
    { field: 'severe',tooltipField: 'severe',headerName: 'Severe'},
    { field: 'high',tooltipField: 'high',headerName: 'High'},
    { field: 'medium',tooltipField: 'medium',headerName: 'Medium Score'},
    { field: 'low',tooltipField: 'low',headerName: 'Low'},
    { field: 'amlStatus',tooltipField: 'amlStatus',headerName: 'PEP/AML Check'},
    { field: 'website',tooltipField: 'website',headerName: 'Website' },    
    { field: 'user_activity',tooltipField: 'user_activity',headerName: 'User Activity'},
    { field: 'documents',tooltipField: 'documents',headerName: 'Documents'},

    { field: 'userActivity_1',tooltipField: 'userActivity_1',headerName: 'userActivity_1',hide:true},
    { field: 'userActivity_2',tooltipField: 'userActivity_2',headerName: 'userActivity_2',hide:true} ,  
    { field: 'userActivity_3',tooltipField: 'userActivity_3',headerName: 'userActivity_3',hide:true},
    { field: 'userActivity_4',tooltipField: 'userActivity_4',headerName: 'userActivity_4',hide:true},
    { field: 'userActivity_5',tooltipField: 'userActivity_5',headerName: 'userActivity_5',hide:true},
    { field: 'userActivity_6',tooltipField: 'userActivity_6',headerName: 'userActivity_6' ,hide:true},    
    { field: 'userActivity_7',tooltipField: 'userActivity_7',headerName: 'User Activity',hide:true},
    { field: 'userActivity_8',tooltipField: 'userActivity_8',headerName: 'userActivity_8',hide:true},
    { field: 'userActivity_9',tooltipField: 'userActivity_9',headerName: 'userActivity_9',hide:true},
    { field: 'userActivity_10',tooltipField: 'userActivity_10',headerName: 'userActivity_10',hide:true },    
    { field: 'userActivity_11',tooltipField: 'userActivity_11',headerName: 'userActivity_11',hide:true},
    { field: 'userActivity_12',tooltipField: 'userActivity_12',headerName: 'userActivity_12',hide:true},
    { field: 'userActivity_13',tooltipField: 'userActivity_13',headerName: 'userActivity_13',hide:true},
    { field: 'userActivity_14',tooltipField: 'userActivity_14',headerName: 'userActivity_14' ,hide:true},    
    { field: 'userActivity_15',tooltipField: 'userActivity_15',headerName: 'userActivity_15',hide:true},
  ];
  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  // tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs)];
  private gridApi!: GridApi;
  private filterObj: any = {};
 
  @ViewChild('modalAdd') private modalAddComponent: ModalComponent
  @ViewChild('modalMerchant') private modalMerchantComponent: ModalComponent

public businessTypeOptions: DropDownValues[];
  private innerWidth: number;
  private _event: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  Resultdata: any;
  private gridColumnApi!: ColumnApi;
  totalRecord: any;

  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService) {
 
    console.log("============>", this.tableSelectedColumn);    
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.bussinessCategories.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.bussinessCategories).slice(0, 10))
    );
  maxSize: number;
  ellipses: boolean= true;

  async ngOnInit(): Promise<void> {
    
   // this.getRiskData();
   this.getSummaryReportData();
    this.getBusinessCatigory();

    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.modalConfigBlocked = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
   const businessType$ = this.merchantService.getBusinessType();
    this.businessTypeOptions = await lastValueFrom(businessType$);
    this.MerchnatList()

    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log(this.innerWidth, "------->");
    this._event = event;
    this.innerWidth = window.innerWidth;
    this.setPageSize();
  }

  onSortChange(event : any){
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }
  changeDate(){
    this.currentDate=this.searchFromDate
  }
  changeEndDate()
  {
    this.currentDate=this.searchToDate
  }
  setPageSize(){   
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;     
    }   
  }

  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {        
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }
  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {     
      this.categorysearch.handleClearClick();
      this.subCategorySearch.handleClearClick();
      this.risksearch.handleClearClick();  
      this.searchFromDate = '';
      this.searchToDate = '';
      this.refreshGrid();
    }
  }

  onSearchBtnClick($event: Event) {  
  }

  closeModalAdd($event: any) {
    if (!$event.showModal) {
      this.modalAddComponent.close();
      this.refreshGrid();
    }
  }
 
  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});
   // this.getRiskData();  
    this.getSummaryReportData() ;
  }


  onGridReady(params: GridReadyEvent<IMerchantData>) {
    debugger
    this.gridApi = params.api;
  //  params.api.setSortModel([{ colId: 'merchantId', sort: 'asc' }])
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    //this.getRiskData();
    this.getSummaryReportData();
  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    return this.apiHttpService
      .get(
        `${API_URL}/get-merchant`
      )
      // @ts-ignore
      .subscribe((data) => (this.gridApi.applyTransaction({add: data})));
  }


 

// downloadExcel() {
//   const random3 = Math.floor(Math.random() * 10000000000 + 1);
//   const today = new Date();
//   const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
//   const fileTitle = 'Merchant Summary Report' + "_" + referenceId;

//  // let fileTitle = this.DynamicScreenControls[0].title + ".xlsx";
 



  
//   this.exportAsExcelFile(this.rowData, fileTitle);
//   }
//   public exportAsExcelFile(rowData: any[], fileName: string): void {
//     const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
//     const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
//     const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//     this.saveAsExcelFile(excelBuffer, fileName);
//   }

//   private saveAsExcelFile(buffer: any, fileName: string): void {
//     const data: Blob = new Blob([buffer], {type: 'application/octet-stream'});
//     const url: string = window.URL.createObjectURL(data);
//     const link: any = document.createElement('a');
//     link.href = url;
//     link.download = fileName;
//     link.click();
//   }















  onExportCSV() {
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Merchant Summary Report' + "_" + referenceId;
    const filter: MerchantFilter = {}
   
    filter.columns = {};
    this.tableSelectedColumn.forEach((col) => {
      if (col?.field) filter['columns'][col?.field] = col?.headerName
    })
    
    return this.merchantService.downloadSummaryReportData(this.riskScore,this.merchantID,this.bussinessCategory,this.subBussinessCategory,this.bussinesstype).subscribe((data:any) => {
        debugger
        let aa1:any=[]
      
  //     aa1= this.rowData[0].user_activity.split("|");
  //       //aa1= data.merchantsSummery[0].finaluser_activity;
  //       // for(let fieldvalue of aa1){
          
  //       // }
  //      // console.log("aa1==="+aa1[0])
  //      // let aa= data.merchantsSummery[0].user_activity.split('|').map((dd:any,index:number):any=> { return { activity:"Activity" + (index+1),value:aa1[0]}})
  //      // this.activityData=[];
  //      // this.activityResponse=[];
  //  for (let i = 0; i < aa1.length; i++) {
       
  //         this.activityData= this.rowData[0].user_activity.split('|').map((dd:any,index:number,activity:any):any=> { return { activity:"userActivity"+" "+(index+1),value:aa1[i]}})
  //       // if(!this.tableSelectedColumn.includes(this.activityData[i].activity)){
  //         //console.log("aa1==="+JSON.stringify(aa[i]))
  //         //alert("aa1==="+JSON.stringify(aa[i]))
  //        this.tableSelectedColumn.push( { field: this.activityData[i].activity,tooltipField: this.activityData[i].activity,headerName: this.activityData[i].activity});
  //      // }
  //     }
      //data.merchantsSummery[0].push( this.tableSelectedColumn);

      //this.rowData = data?.merchantsSummery  || data || [],   
      this.collectiondata = data?.totalRecords||0   
//alert(this.collectiondata)
        const expData: any[] = [];
        ( data?.merchantsSummery  || data || []).forEach((curr: any) => {
          const tempRec: any = {}         
          this.tableSelectedColumn.forEach((col) => {
            debugger
            if(!(col?.field=="actions"))
            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]
          }       
        })
        debugger

          expData.push(tempRec);
      //    this.gridApi.setColumnDefs([{field:"xyz"}]);

        })       
        this.exportAsExcelFile(expData, fileName);
      })
      //this.exportAsExcelFile(this.rowData, fileName);

  }
  public exportAsExcelFile(json: any[], excelFileName: string): void {
    debugger
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
   
      header: [...tempRec.map((col:any) => col.headerName)]
    });  
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    debugger    
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }



  searchQuickFilter($event?: NgbTypeaheadSelectItemEvent) {
    this.gridApi.setQuickFilter($event?.item);
  }

  onGlobalSearchChange($event: any) {
    if ($event == '' || $event == null) {
      this.gridApi.setQuickFilter($event);
    }
  }
  async MerchantNew() {
    return await this.modalMerchantComponent.open();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.page=param;
    debugger
    this.gridApi.applyTransaction({remove: this.rowData})
     this.gridApi.showLoadingOverlay();   
    this.getSummaryReportData();   
  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }


  async onRowDoubleClicked(param: RowClickedEvent | any) {    
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {  
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {
    debugger
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
   
this.getSummaryReportData();
  }
  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }
  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  allowAlfanumeric(event: Event): void {  
    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }

 // req:any;
 
 getRiskData(){
  
//   this.merchantService.getRiskData(this.valevent1,this.valevent2,this.valevent3,this.pageSize,this.page).subscribe((data)=>{   
//     this.rowData = data?.data  || data || [],   
//     this.collectiondata = data[0]?.totalRecord||0   
//     this.collectionSize=this.collectiondata  
//     if(this.rowData.length <=0){
//       this.alertService.errorAlertWithMessage("No records present");
//       return }

//   }
//   )
}
getSummaryReportData(){  
  this.merchantService.getSummaryReportData(this.riskScore,this.merchantID,this.bussinessCategory,this.subBussinessCategory,this.bussinesstype,this.pageSize,this.page).subscribe((data)=>{   
    console.log("getSummaryReportDatarowData=="+JSON.stringify(data?.merchantsSummery));
    // this.rowData = data?.content  || data || [],
    this.rowData = data?.merchantsSummery  || data || [],   
    this.collectiondata = data?.totalRecords||0   
    
    this.collectionSize=this.collectiondata;
    if(this.collectiondata <=0){
      this.alertService.errorAlertWithMessage("No records present");
      this.rowData=[];
      return }
  }
  )
}
searchbypayid(event:any){
  //alert(event)
  if(event==undefined){   
    this.merchantID=""
    //this.getSummaryReportData(); 
  }
else{
  this.merchantID=event;   
   // this.getSummaryReportData();   
  }  
}

categoryTypeOptions:any;
getBusinessCatigory(){
  debugger
  this.merchantService.getCategoryType().subscribe((data)=>{
   this.categoryTypeOptions=data;
  
  
    console.log("response=="+JSON.stringify(data))
    console.log("data=="+data)
  })
}
onselectBusinessType(event:any){
//alert(event)
  if(event==undefined){
     this.bussinesstype=""
     //this.getSummaryReportData();     
  }
else{
  this.bussinesstype=event;   
    //this.getSummaryReportData();   
  }  



}

onselectBusinessCat(event:any){

  if(event==undefined){   
     this.bussinessCategory=""
     this.subBussinessCategory="" 
     this.searchMID="" 
     this.subCategoryTypeOptions=[]
   // this.getSummaryReportData();  
   }
else{
  // riskScore:any=""
  // merchantID:any=""
  // bussinessCategory:any=""
  // subBussinessCategory:any=""
  // bussinesstype:any=""
  this.bussinessCategory=event;   
   // this.getSummaryReportData();   
    this.getBusinessSubCatigory();
  } 

  //alert(event);
}
onselectBusinessSubCat(event:any){
  if(event==undefined){
   
     this.subBussinessCategory=""
    // this.getSummaryReportData();   
  }
else{
  this.subBussinessCategory=event;   
   // this.getSummaryReportData();  
    
  } 

  //alert(event);
}

onselectRiskLevelCode(event:any){
  this.page= 1
  //alert(event)  
  if(event==undefined){
    this.riskScore=""
   // this.getSummaryReportData();  
  }
else{
  this.riskScore=event;   
   // this.getSummaryReportData();   
    
  } 
}
riskcode:any= [
  // { code: 0, value: 0 },
  { code: 1, value: 1 },
  { code: 2, value: 2 },
  { code: 3, value: 3 },
  { code: 4, value: 4 },
  ];
// riskcode=[
//   code="1",
// ]
subCategoryTypeOptions:any;
getBusinessSubCatigory(){
  debugger

  //if(this.valevent1){
    debugger
  this.merchantService.getSubCategoryType(this.bussinessCategory).subscribe((data)=>{
  this.subCategoryTypeOptions=data;
    console.log("subCategoryTypeOptions=="+JSON.stringify(this.subCategoryTypeOptions))
    console.log("subCategoryTypeOptions=="+this.subCategoryTypeOptions)
  })
//}
}

MerchnatList() {
  let reqData = {
    "name": ""
  }
  console.log("request body", reqData)
  this.merchantService.getMerchantBYName(reqData).subscribe((res:any) => {
      this.Resultdata = res
      console.log("merchant mid",res)
    });
}
isDropdownOpen = false; // Variable to track the dropdown state

 // HostListener to detect clicks outside of the ng-select element
  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
    debugger
    const ngSelectElement = document.querySelector('ng-select');

    // Check if the clicked target is outside the ng-select element and the dropdown is open
    if (!ngSelectElement?.contains(target) && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }
}
